import { Component, Input, OnInit } from '@angular/core';
import { DataShareService } from '@shared/services/data-share.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-institution-title',
  templateUrl: './institution-title.component.html',
  styleUrls: ['./institution-title.component.scss']
})
export class InstitutionTitleComponent implements OnInit {

  institutionTitle = '';
  acgme: any;
  residencyProgramId: any;

  constructor(private dataShareService: DataShareService,
              private sessionService: SessionService) { }

  ngOnInit() {
    this.dataShareService.currentMessage.subscribe(message => {
      this.institutionTitle = message;
      this.acgme = this.sessionService.getAcgme();
      this.residencyProgramId = this.sessionService.getInstitutionId();
    });

  }

  getSubtext() {
    const strArr = [];
    if (this.acgme) { strArr.push(`ACGME Number: ${this.acgme}`); }
    if (this.residencyProgramId) { strArr.push(`AAOS Residency Program ID: ${this.residencyProgramId}`); }

    return strArr.join('&emsp;-&emsp;');
  }

}
